import authApi from "./authApi";

/** Swagger: /api/auth/user/user/* */
const USER = "/user/user";

// Collapse Strict Mode + SidebarLayout/Settings double-fetch into one /profile request
let inflightProfile = null;
let profileCache = null;
let profileCacheAt = 0;
const PROFILE_TTL_MS = 8000;

export async function getUserProfile({ force = false } = {}) {
	if (!force && profileCache && Date.now() - profileCacheAt < PROFILE_TTL_MS) {
		return profileCache;
	}
	if (inflightProfile) return inflightProfile;

	inflightProfile = (async () => {
		try {
			const { data } = await authApi.get(`${USER}/profile`);
			profileCache = data;
			profileCacheAt = Date.now();
			return data;
		} finally {
			inflightProfile = null;
		}
	})();

	return inflightProfile;
}

// Collapse Strict Mode double-mount into one in-flight /me request
let inflightAuthMe = null;
let authMeCache = null;
let authMeCacheAt = 0;
const AUTH_ME_TTL_MS = 8000;

export async function getAuthMe({ force = false } = {}) {
	if (!force && authMeCache && Date.now() - authMeCacheAt < AUTH_ME_TTL_MS) {
		return authMeCache;
	}
	if (inflightAuthMe) return inflightAuthMe;

	inflightAuthMe = (async () => {
		try {
			const { data } = await authApi.get("/me");
			authMeCache = data;
			authMeCacheAt = Date.now();
			return data;
		} finally {
			inflightAuthMe = null;
		}
	})();

	return inflightAuthMe;
}
